import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuditingState } from './auditing.reducer';

export const selectAuditing = createFeatureSelector<AuditingState>('auditing');
